import * as tslib_1 from "tslib";
// Core packages
import { OnDestroy, OnInit } from "@angular/core";
// Third party packages
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { CookieService } from "ngx-cookie-service";
import { forkJoin } from "rxjs";
// Custom packages
import { ExportRasDocsDialogComponent } from "src/app/modules/properties/components/export-ras-docs-dialog/export-ras-docs-dialog.component";
import { DocumentArchiveDocsService } from "src/app/modules/properties/document-archive-docs.service";
import { documentArchiveExportLoadErrorKey, documentArchiveRasAddress, documentArchiveRasPdfItems, } from "src/app/modules/properties/document-archive-export.utils";
import { PropertiesService } from "src/app/modules/properties/properties.service";
import { isArchiveObjectId } from "src/app/modules/search-docs/document-archive-general-search.utils";
import { SettingsService } from "src/app/modules/settings/settings.service";
import { ConfigService } from "src/app/shared/services/config.service";
import { HelperService } from "src/app/shared/services/helper.service";
/**
 * «Esporta RAS» of the dossier on the 3.0.0 archive (FE-M8).
 *
 * The legacy dialog with its data source swapped: it EXTENDS `ExportRasDocsDialogComponent` and only
 * replaces how the lines are read, so the PDF is written by the very `onExportFile` of the legacy, cover,
 * tables, marks and all. The legacy dialog stays as it is for the legacy dossier until the switch.
 *
 * What changes is where the lines come from:
 *  - `GET /document-archive-docs/ras` (NEW-M7) instead of `properties/:id/ras-docs`;
 *  - no `document-archives/settings` and no section computed from the retired `key`: the QR code of a
 *    document is `/qrcode/d/{_id of the row}` (NEW-A3), @see documentArchiveRasPdfItems;
 *  - a failure says so, instead of the legacy "nothing to export".
 *
 * The cover prints `data.companyName`, which the legacy dossier never passes either: same output.
 *
 * @since 3.0.0
 */
var DocumentArchiveExportRasDialogComponent = /** @class */ (function (_super) {
    tslib_1.__extends(DocumentArchiveExportRasDialogComponent, _super);
    /**
     * Class constructor: the dependencies of the legacy dialog, and the service of the new archive
     */
    function DocumentArchiveExportRasDialogComponent(dialogRef, data, configService, cookieService, translateService, propertiesService, helperService, settingsService, documentArchiveDocsService) {
        var _this = _super.call(this, dialogRef, data, configService, cookieService, translateService, propertiesService, helperService, settingsService) || this;
        _this.documentArchiveDocsService = documentArchiveDocsService;
        /** Translation key of the message shown when the lines cannot be read, `""` when they could */
        _this.loadErrorKey = "";
        _this.cookies = cookieService;
        _this.properties = propertiesService;
        return _this;
    }
    /**
     * Read the property, for the cover, and the lines of the RAS, together. Replaces the legacy
     * `ngOnInit` entirely: none of its calls is made.
     *
     * @since 3.0.0
     */
    DocumentArchiveExportRasDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.lang = this.cookies.get("lang") || this.configService.defaultLang;
        var propertyId = this.data ? this.data.propertyId : undefined;
        if (!isArchiveObjectId(propertyId)) {
            this.dialogIsLoading = false;
            this.loadErrorKey = documentArchiveExportLoadErrorKey(null);
            return;
        }
        this.loadSubscription = forkJoin([
            this.properties.get(propertyId),
            this.documentArchiveDocsService.rasDocs(propertyId),
        ]).subscribe(function (results) {
            _this.dialogIsLoading = false;
            var propertyRes = results[0];
            // ApiService emits a network failure of the legacy route as a VALUE
            if (propertyRes instanceof Error) {
                _this.loadErrorKey = documentArchiveExportLoadErrorKey(propertyRes);
                return;
            }
            var property = propertyRes && propertyRes.status && propertyRes.data ? propertyRes.data : null;
            var ras = results[1] && results[1].data ? results[1].data : null;
            if (!property || !ras || !ras.status) {
                _this.loadErrorKey = documentArchiveExportLoadErrorKey(null);
                return;
            }
            _this.property.setData(property);
            _this.propertyData = property;
            _this.propertyName = typeof property.name === "string" ? property.name : "";
            _this.propertyAddress = documentArchiveRasAddress(property.address);
            var composed = documentArchiveRasPdfItems(ras.rasDocs, _this.configService.frontEndHost);
            _this.documentArchive = composed.items;
            _this.totalPages = composed.totalPages;
        }, function (err) {
            _this.dialogIsLoading = false;
            _this.loadErrorKey = documentArchiveExportLoadErrorKey(err);
        });
    };
    /**
     * Destroy component
     *
     * @since 3.0.0
     */
    DocumentArchiveExportRasDialogComponent.prototype.ngOnDestroy = function () {
        if (this.loadSubscription) {
            this.loadSubscription.unsubscribe();
        }
    };
    return DocumentArchiveExportRasDialogComponent;
}(ExportRasDocsDialogComponent));
export { DocumentArchiveExportRasDialogComponent };
/**
 * Open «Esporta RAS» of the 3.0.0 archive for a property, at the size and with the closing rule of the
 * legacy dialog: how the legacy pages that keep the export open it once the switch is live.
 *
 * @since 3.0.0
 *
 * @param dialog     The MatDialog of the page
 * @param propertyId The property
 */
export function openDocumentArchiveExportRasDialog(dialog, propertyId) {
    var data = { propertyId: propertyId };
    return dialog.open(DocumentArchiveExportRasDialogComponent, {
        width: "700px",
        data: data,
        disableClose: true,
    });
}
